import * as React from 'react';
import * as firebase from 'firebase' ; 
import { Link } from 'react-router-dom';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { SecurityData } from '../shared/index';
// import { firebaseApp } from 'src/base/FirebaseInit';

export interface MyAccountMenuProps extends BaseComponentProps {
  lang: string;
  user: SecurityData.ApplicationUser;
  user_login: boolean;
  hengleUserDialogClose: () => any;
  userAccess: string; 
  firebaseApp: firebase.app.App ; 
}
export interface MyAccountMenuState extends BaseComponentState { }
export class MyAccountMenu extends BaseComponent<MyAccountMenuProps, MyAccountMenuState> {

  constructor(props: MyAccountMenuProps) {
    super(props);

  }
  render() {
    if (this.state.haveReactError) {
      return this.renderErrorPanel();
    }
    
    let display = 'none';
    if (this.props.userAccess === "SALES" || this.props.userAccess === "ADMIN") {
      display = "block";
    } 
    return (
      <div className="list-group">
        <Link className="list-group-item " to="/my-account" onClick={this.props.hengleUserDialogClose}> View My Profile </Link>
        <Link className="list-group-item" to='/my-account/my-booking' style={{display: display}}  onClick={this.props.hengleUserDialogClose}> Manage My Booking </Link>
        <Link className="list-group-item" to='/my-account/my-1-dolar-deposit' style={{display: display}}  onClick={this.props.hengleUserDialogClose}> $1 Deposit </Link>        
        <Link className="list-group-item" to='/my-account/my-wishlist' style={{display: display}}  onClick={this.props.hengleUserDialogClose}> My Wishlist </Link>
        <Link className="list-group-item" to='/my-account/my-reviews' style={{display: display}}  onClick={this.props.hengleUserDialogClose}> Discush and Reviews </Link>  
        <a
          className="list-group-item"
          onClick={
            () => {
              let Fb = this.props.firebaseApp.auth();
              Fb.signOut().then(
                ev => {
                  location.href = "/";
                }
              );
            }
          }
        > Logout
        </a>
      </div>

    );
  }
}

/*
  menu yang belum active 

  <Link className="list-group-item" to='/my-account/my-rewards'   onClick={this.props.hengleUserDialogClose}  > My Rewards Point History</Link>
 */


// WEBPACK FOOTER //
// ./src/my-account/MyAccountMenu.tsx